var formStep = 1;

var intersectingElectorates = [];
var targetElectorate = null;

var stateOrTerritory = null;
var senators = [];

var sender = {};

function handleError(error, cta = 'Continue') {
    var activeFormSelector = jQuery('[data-form-step="' + formStep + '"] form');
    if (activeFormSelector.length > 0) {
        activeFormSelector.removeClass('loading');

        var submitSelector = activeFormSelector.children('button[type="submit"]');
        submitSelector.text(cta);
    }

    jQuery('.alert[data-form-step-error="' + formStep + '"]').removeClass('hide');
    var errorMessage = typeof error === 'string' ? error : (error.message ?? "No error message provided!");
    console.error(errorMessage);
}

function setFormStep(step) {
    if (formStep !== step) {
        jQuery('[data-form-step="' + formStep + '"]').addClass('hide');
    }

    formStep = step;
    jQuery('[data-form-step="' + formStep + '"]').removeClass('hide');
}

function replaceTextContent() {
    if (targetElectorate !== null) {
        var member = targetElectorate.member;

        // Text on the sender details and email content steps.
        jQuery('[data-replace-text="member-name"]').text(member.fullName);
        jQuery('[data-replace-text="member-party"]').text(member.partyName);
        jQuery('[data-replace-text="member-electorate"]').text(targetElectorate.name);
    }

    if (stateOrTerritory !== null) {
        jQuery('[data-replace-text="state-territory"]').text(stateOrTerritory);
    }
}

function replaceEmailBodyContent() {
    var emailBodySelector = jQuery('#email-body');
    var emailBodyHtml = emailBodySelector.html();
    emailBodyHtml = emailBodyHtml.replaceAll('[sender-name]', (sender.firstName + ' ' + sender.lastName));

    if (targetElectorate !== null) {
        var member = targetElectorate.member;
        emailBodyHtml = emailBodyHtml.replaceAll('[member-name]', member.fullName);
    }

    emailBodySelector.html(emailBodyHtml);
}

function generateRecipients() {
    var recipients = [];

    if (targetElectorate !== null) {
        recipients.push({
            fullName: targetElectorate.member.fullName,
            emailAddress: targetElectorate.member.emailAddress,
            sendingMethod: "direct"
        });
    } else {
        for (var i = 0; i < intersectingElectorates.length; i++) {
            var electorate = intersectingElectorates[i];
            var member = electorate.member;

            recipients.push({
                fullName: member.fullName,
                emailAddress: member.emailAddress,
                sendingMethod: "direct"
            });
        }
    }

    if (emailSenators && senators.length > 0) {
        for (var i = 0; i < senators.length; i++) {
            var senator = senators[i];

            recipients.push({
                fullName: senator.fullName,
                emailAddress: senator.emailAddress,
                sendingMethod: "bcc"
            });
        }
    }

    return recipients;
}

function displayIntersectingElectorates() {
    for (var i = 0; i < intersectingElectorates.length; i++) {
        var electorate = intersectingElectorates[i];
        var member = electorate.member;

        var electorateHtml = '<div class="intersecting-electorate p-3 mb-3" data-index="' + i + '">';
        electorateHtml += '<strong class="member-name">' + member.fullName + '</strong>';
        electorateHtml += '<div class="member-details">' + member.partyName + ' Member for ' + electorate.name + '</div>';
        electorateHtml += '</div>';

        jQuery('.intersecting-electorates').append(electorateHtml);
    }

    jQuery('.intersecting-electorate[data-index]').on('click', function (event) {
        event.preventDefault();

        var index = jQuery(this).attr('data-index');
        if (!isNaN(index) && index >= 0) {
            var selectedElectorate = intersectingElectorates[index];
            if (selectedElectorate) {
                targetElectorate = selectedElectorate;
                replaceTextContent();
                setFormStep(3);
            } else {
                handleError('The selected index does not match an intersecting electorate!');
            }
        } else {
            handleError('Invalid index on selected electorate!');
        }
    });
}

window.addEventListener('load', function () {
    if (isActionPage) {
        jQuery(document).off('submit');

        if (window.fetch) {
            jQuery('.browser-unsupported').addClass('hide');
            setFormStep(1);
        }

        // Step 1 - Enter postcode
        jQuery('form#postcode-input-form').on('submit', function (event) {
            event.preventDefault();

            // Hide error.
            jQuery('.alert[data-form-step-error="' + formStep + '"]').addClass('hide');

            // Show loading state.
            jQuery(this).addClass('loading');
            var submitSelector = jQuery(this).children('button[type="submit"]');
            submitSelector.text('Please wait...');

            var postcode = jQuery('#postcode-input').val();
            fetch(geodataDomain + '/electorate/au/postcode/' + postcode + '/electoratesAndSenators', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + geodataAuthKey
                }
            })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                if (response.success) {
                    intersectingElectorates = response.response.electorates;

                    sender.postcode = Number(postcode);

                    stateOrTerritory = response.response.stateOrTerritory;
                    senators = response.response.senators;

                    if (intersectingElectorates.length === 0) {
                        handleError('No intersecting MPs found!');
                    } else if (intersectingElectorates.length === 1) {
                        targetElectorate = intersectingElectorates[0];
                        replaceTextContent();
                        setFormStep(3);
                    } else if (skipMpSelection) {
                        replaceTextContent();
                        setFormStep(3);
                    } else {
                        displayIntersectingElectorates();
                        setFormStep(2);
                    }
                } else {
                    handleError(response.error);
                }
            })
            .catch(function (error) {
                handleError(error);
            });
        });

        // Step 2 - Select MP
        // This event listener is declared after the list of intersecting electorates is dynamically generated.

        // Step 3 - Sender Details
        jQuery('form#sender-details-form').on('submit', function (event) {
            event.preventDefault();

            sender.firstName = jQuery('#first-name').val().trim();
            sender.lastName = jQuery('#last-name').val().trim();
            sender.email = jQuery('#email').val().trim();

            replaceEmailBodyContent();
            setFormStep(4);
        });

        // Step 4 - Send Email
        jQuery('form#email-form').on('submit', function (event) {
            event.preventDefault();

            // Hide error.
            jQuery('.alert[data-form-step-error="' + formStep + '"]').addClass('hide');

            // Show loading state.
            jQuery(this).addClass('loading');
            var submitSelector = jQuery(this).children('button[type="submit"]');
            submitSelector.text('Please wait...');

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, {
                    action: 'submit'
                }).then(function (userResponseToken) {
                    var requestBody = {
                        sender: {
                            firstName: sender.firstName,
                            lastName: sender.lastName,
                            emailAddress: sender.email
                        },
                        emailContent: {
                            subject: jQuery('#email-subject').val().trim(),
                            body: jQuery('#email-body').html()
                        },
                        customRecipients: generateRecipients(),
                        additionalFields: {
                            postcode: sender.postcode
                        },
                        recaptchaUserToken: userResponseToken
                    };

                    if (targetElectorate !== null) {
                        requestBody.additionalFields.electorate = targetElectorate.name;
                        requestBody.additionalFields.federalMemberPoliticalParty = targetElectorate.member.partyName;
                    }

                    if (typeof testingRecipients !== 'undefined' && Array.isArray(testingRecipients) && testingRecipients.length > 0) {
                        requestBody.customRecipients = testingRecipients;
                    }

                    fetch(emailRequestDomain + '/send/email/' + emailCampaignUuid, {
                        method: 'POST',
                        body: JSON.stringify(requestBody),
                        headers: {
                            'Authorization': 'Bearer ' + emailSendingAuthKey,
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (response) {
                        if (response.success && response.response && response.response.sendingInitiated) {
                            setFormStep(5);
                        } else {
                            handleError(response.message, 'Send email');
                        }
                    })
                    .catch(function (error) {
                        handleError(error, 'Send email');
                    });
                });
            });
        });
    }
});